<template>
	<checkout-block v-if="showOrderLine">
		<checkout-block-header>{{ orderLine.ProductName }}</checkout-block-header>

		<checkout-block-body>
			<div v-if="orderLine.ProductType == 2">
				<participant-form
					v-for="(participant, i) in orderLine.Participants"
					:key="i"
					:participant="participant"
					:index="i"
					:ol-index="index"
				></participant-form>
			</div>
			<div v-if="orderLine.ProductType == 3 || orderLine.ProductType == 4">
				<team-form
					v-for="(team, i) in orderLine.Teams"
					:key="i"
					:team="team"
					:edit-participants="orderLine.ProductType == 4"
					:blankTeam="orderLine.BlankTeam"
					:index="i"
				></team-form>
			</div>
		</checkout-block-body>
	</checkout-block>
</template>

<script>
import TeamForm from "./TeamForm";
import ParticipantForm from "./ParticipantForm";

export default {
	props: {
		orderLine: Object,
		index: Number
	},
	components: {
		TeamForm,
		ParticipantForm
	},
	computed: {
		checkoutState: function() {
			return this.$store.getters.checkoutState;
		},
		isMobilePayCheckout: function() {
			return this.checkoutState == "mobilePay";
		},
		isMemberCheckout: function() {
			return this.checkoutState == "member";
		},
		isRegularCheckout: function() {
			return !this.isMobilePayCheckout && !this.isMemberCheckout;
		},
		showOrderLine: function() {
			if (this.isRegularCheckout) {
				return true;
			}

			if (
				this.orderLine.ProductType == 2 &&
				this.orderLine.Participants.filter(
					p =>
						p.CustomFields.length == 0 &&
						p.ProductProperties.length == 0 &&
						p.DropdownProperties.length == 0
				).length > 0
			) {
				return false;
			}

			return true;
		}
	}
};
</script>
